//#region src/date-time/date-format-enum.ts
var e = /* @__PURE__ */ function(e) {
	return e.dateFirst = "d/m/Y", e.monthFirst = "m/d/Y", e;
}({});
//#endregion
export { e as DateFormatEnum };
